import { Input, Skeleton, Stack, Text } from "@chakra-ui/react";
import { useMemo, useState } from "react";
import ConnectionCard from "./ConnectionCard";
import type { MatrimonyConnection } from "src/types/matrimonyConnections.types";

type Props = {
  items: MatrimonyConnection[];
  isLoading?: boolean;
  onViewProfile?: (id: string | number) => void;
};

export default function ConnectionsList({ items, isLoading, onViewProfile }: Props) {
  const [query, setQuery] = useState("");

  const filteredItems = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return items;
    return items.filter((c) => String(c?.profile?.fullName || "").toLowerCase().includes(q));
  }, [items, query]);

  if (isLoading) {
    return (
      <Stack spacing={4}>
        <Input
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search connections"
          bg="#F8F9FA"
          borderRadius="12px"
          borderColor="rgba(108, 117, 125, 0.3)"
          height="44px"
          aria-label="Search connections"
        />
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} height={{ base: "140px", md: "120px" }} borderRadius="16px" />
        ))}
      </Stack>
    );
  }

  if (!items.length) {
    return (
      <Text color="#6C757D" py={6} textAlign="center">
        No connections yet.
      </Text>
    );
  }

  return (
    <Stack spacing={4}>
      <Input
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Search connections"
        bg="#F8F9FA"
        borderRadius="12px"
        borderColor="rgba(108, 117, 125, 0.3)"
        height="44px"
        aria-label="Search connections"
      />

      {!filteredItems.length ? (
        <Text color="#6C757D" py={6} textAlign="center">
          No matches found.
        </Text>
      ) : (
        filteredItems.map((c) => (
          <ConnectionCard key={String(c.id)} profile={c.profile} onViewProfile={onViewProfile} />
        ))
      )}
    </Stack>
  );
}
